"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const brands = [{
  name: "Xiaomi",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626966/img/reparacion_baterias_xiaomi_sevilla.png",
  seoTitle: "Reparación de baterías Xiaomi en Sevilla",
  description: "Especialistas en arreglar baterías de patinetes Xiaomi con repuestos originales en Sevilla, Mairena del Aljarafe y el Aljarafe."
}, {
  name: "SmartGyro",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626966/img/reparacion_baterias_smartgyro_sevilla.png",
  seoTitle: "Reparación de baterías SmartGyro en Sevilla",
  description: "Servicio técnico experto en baterías SmartGyro para mayor autonomía en Sevilla, Mairena del Aljarafe y Aljarafe."
}, {
  name: "Kukirin",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626966/img/reparacion_baterias_kukirin_sevilla.png",
  seoTitle: "Reparación de baterías Kukirin en Sevilla",
  description: "Reparamos y optimizamos baterías Kukirin en nuestro taller especializado de Sevilla, Mairena del Aljarafe y Aljarafe."
}, {
  name: "Cecotec",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626966/img/reparacion_baterias_cecotec_sevilla.png",
  seoTitle: "Reparación de baterías Cecotec en Sevilla",
  description: "Soluciones profesionales para baterías Cecotec agotadas o dañadas en Sevilla, Mairena del Aljarafe y Aljarafe."
}, {
  name: "Dualtron",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626966/img/reparacion_baterias_dualtron_sevilla.png",
  seoTitle: "Reparación de baterías Dualtron en Sevilla",
  description: "Mantenimiento y reparación de baterías de alta gama Dualtron en Sevilla, Mairena del Aljarafe y Aljarafe."
}];
export default function CompatibleBrands() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: logosRef,
    isVisible: areLogosVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="177573" id="marcas-que-reparamos-en-sevilla" className="bg-background text-foreground py-16 md:py-24 relative border-y border-border/40 overflow-hidden">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:3rem_3rem] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_50%,#000_40%,transparent_100%)] opacity-[0.15] dark:opacity-[0.05] pointer-events-none" aria-hidden="true" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={headerRef} className={`text-center mb-12 md:mb-16 transition-all duration-700 ease-out transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-foreground font-default uppercase">
            Especialistas en las <span className="text-primary">Marcas Líderes</span> que reparamos en Sevilla
          </h1>
          <h2 className="mt-4 text-lg text-muted-foreground max-w-2xl mx-auto">
            Servicio técnico especializado para toda la provincia, incluyendo Mairena del Aljarafe y la comarca del Aljarafe.
          </h2>
          <p className="mt-4 text-muted-foreground max-w-2xl mx-auto">
            Como especialistas en Sevilla, optimizamos el rendimiento de tu vehículo eléctrico. Nuestra ubicación estratégica nos permite ofrecer un servicio ágil en Mairena del Aljarafe y todo el Aljarafe, garantizando reparaciones precisas con componentes de alta calidad.
          </p>
        </div>

        <div ref={logosRef} className={`flex flex-wrap justify-center items-center gap-10 md:gap-16 lg:gap-24 transition-all duration-700 delay-200 ease-out transform ${areLogosVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {brands.map((brand, i) => <div key={brand.name} data-index={i} className="group relative flex items-center justify-center w-28 h-12 md:w-36 md:h-16 cursor-pointer">
              <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out pointer-events-none" />
              
              <img src={brand.logo} alt={`${brand.name}: reparación batería patinete Sevilla, baterías litio Sevilla, diagnóstico baterías Sevilla`} title={brand.seoTitle} data-description={brand.description} width="112" height="48" className="max-w-full max-h-full object-contain grayscale opacity-50 transition-all duration-500 ease-out group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-110 relative z-10" loading="lazy" />
            </div>)}
        </div>
      </div>
    </section>;
}